import AppManager from './AppManager';
import Storage from '../Storage';
import { LogBehavioralEvent } from './helpers/appStateLogger';
import Api from '../localPhoton/api';

const storage = new Storage();
const appManager = new AppManager(storage, Api);

export const logEvent = LogBehavioralEvent(appManager);
export default appManager;
